import { Action } from "redux";
import { signInWithCustomToken, signOut } from "firebase/auth";
import { store } from "../store";
import { firebaseAuth } from "../..";

export enum AuthActions {
  AUTH_SAVE_TOKEN = "AUTH_SAVE_TOKEN",
}

export interface AuthSaveTokenAction extends Action<AuthActions.AUTH_SAVE_TOKEN> {
  token: string;
}

const login = async (token: string, prevToken?: string) => {
  try {
    if (prevToken) {
      await signOut(firebaseAuth);
    }
    await signInWithCustomToken(firebaseAuth, token);
  } catch (e) {
    console.log(e);
  }
};

export const saveToken = async (token: string) => {
  const {
    auth: { token: prevToken },
  } = store.getState();
  await login(token, prevToken);
  store.dispatch({ type: AuthActions.AUTH_SAVE_TOKEN, token });
};
